import React, { Component } from 'react';
import PropTypes from 'prop-types';

import getSitemapSearchQuery from '../../common/graphql/queries/sitemap-search';
import SessionExpiredModal from '../../common/components/SessionExpiredModal';
import AppBanner from '../../common/components/AppBanner';

import AllSearchList from './components/AllSearchList';

import './../../common/scss/init.scss';

class AllSearchListContainer extends Component {
  static NAME = 'AllSearchListContainer';

  static contextTypes = {
    data: PropTypes.object
  };

  static async requestAllData(req, domain, { graphqlClient, res }) {
    try {
      const locale = req.locale;
      const { data } = await getSitemapSearchQuery(graphqlClient)({
        locale
      });

      if (data.sitemapSearch.search.length === 0) {
        res.redirect('/404');
        return { data: {} };
      }

      return {
        headers: {
          title: 'Spotahome'
        },
        data
      };
    } catch (err) {
      console.log(err);

      return { data: {} };
    }
  }

  state = {
    data: this.context.data[AllSearchListContainer.NAME] || {}
  };

  render() {
    const { search } = this.state.data.sitemapSearch;

    return (
      <React.Fragment>
        <AllSearchList searchLinkList={search} />
        <SessionExpiredModal />
        <AppBanner />
      </React.Fragment>
    );
  }
}

export default AllSearchListContainer;
